import { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { useNoticeBannersStackActions } from '@garnish/overlays';

import type { UseMutationState, UseQueryState } from 'urql';

export const useNetworkErrorNotice = (
  request: UseQueryState | UseMutationState,
  errorMessage?: string,
) => {
  const hasError = request.error !== undefined;
  const { push: addNoticeBanner } = useNoticeBannersStackActions();
  const { formatMessage } = useIntl();
  const defaultErrorMessage = formatMessage(messages.networkError);
  const text = errorMessage ?? defaultErrorMessage;

  useEffect(() => {
    if (hasError) {
      addNoticeBanner({ text, palette: 'caution' });
    }
  }, [hasError, text, addNoticeBanner]);
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  networkError: {
    defaultMessage: 'Something went wrong, try again in a few moments...',
    description: 'Network Error Notice | Error',
  },
});
